import React from 'react'; // Only need React for JSX
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { bindActionCreators } from 'redux';

// Import the page component and HOC
import EdgeView from './views/EdgeView';

// Import selectors and actions
import * as edgeDevicesSelectors from '../../redux/edge-devices/edgeDevices.selectors';
import * as edgeDevicesActions from '../../redux/edge-devices/edgeDevicesActions';

/**
 * mapStateToProps using createStructuredSelector
 */
const mapStateToProps = createStructuredSelector({
  user: (state) => state.user,
  clusters: (state) => state.edgeDevices.clusters,
  clusterDetails: (state) => state.edgeDevices.clusterDetails,
  clusterHealth: (state) => state.edgeDevices.clusterHealth,
  serviceStatus: (state) => state.edgeDevices.serviceStatus,
  nodes: (state) => state.edgeDevices.nodes,
  unassignedNodes: (state) => state.edgeDevices.unassignedNodes,
  nodeTelemetry: (state) => state.edgeDevices.nodeTelemetry,
  applications: (state) => state.edgeDevices.applications,
  applicationDetails: (state) => state.edgeDevices.applicationDetails,
  services: (state) => state.edgeDevices.services,
  pods: (state) => state.edgeDevices.pods,
  terminalOutput: (state) => state.edgeDevices.terminalOutput,
  terminalConnected: (state) => state.edgeDevices.terminalConnected,
  activeCluster: (state) => state.edgeDevices.activeCluster,
  activeNamespace: (state) => state.edgeDevices.activeNamespace,
  rbacUsers: (state) => state.edgeDevices.rbacUsers,
  roles: (state) => state.edgeDevices.roles,
  pendingDevices: (state) => state.edgeDevices.pendingDevices,
  isFetching: (state) => state.edgeDevices.isFetching,
  isCreating: (state) => state.edgeDevices.isCreating,
  isDeleting: (state) => state.edgeDevices.isDeleting,
  isUpdating: (state) => state.edgeDevices.isUpdating,
  isInstalling: (state) => state.edgeDevices.isInstalling,
  isExecutingCommand: (state) => state.edgeDevices.isExecutingCommand,
  isLoadingRbac: (state) => state.edgeDevices.isLoadingRbac,
  isLoadingDevices: (state) => state.edgeDevices.isLoadingDevices,
  errors: edgeDevicesSelectors.selectErrors,
  rbacError: edgeDevicesSelectors.selectRbacError,
  deviceError: edgeDevicesSelectors.selectDeviceError,
  isNewUser: edgeDevicesSelectors.selectIsNewUser,
});

/**
 * Action creators
 */
const actionCreators = {
  fetchClusters: edgeDevicesActions.fetchClustersStartAsync,
  createCluster: edgeDevicesActions.createClusterStartAsync,
  deleteCluster: edgeDevicesActions.deleteClusterStartAsync,
  updateClusterStatus: edgeDevicesActions.updateClusterStatusStartAsync,
  fetchClusterDetails: edgeDevicesActions.fetchClusterDetailsStartAsync,
  fetchClusterHealth: edgeDevicesActions.fetchClusterHealthStartAsync,
  setActiveCluster: edgeDevicesActions.setActiveCluster,
  fetchNodes: edgeDevicesActions.fetchNodesStartAsync,
  createNode: edgeDevicesActions.createNodeStartAsync,
  fetchNodeTelemetry: edgeDevicesActions.fetchNodeTelemetryStartAsync,
  updateNodeStatus: edgeDevicesActions.updateNodeStatusStartAsync,
  deleteNode: edgeDevicesActions.deleteNodeStartAsync,
  assignNode: edgeDevicesActions.assignNodeStartAsync,
  removeNode: edgeDevicesActions.removeNodeStartAsync,
  transferNode: edgeDevicesActions.transferNodeStartAsync,
  fetchUnassignedNodes: edgeDevicesActions.fetchUnassignedNodesStartAsync,
  fetchApps: edgeDevicesActions.fetchAppsStartAsync,
  installApp: edgeDevicesActions.installAppStartAsync,
  fetchAppDetails: edgeDevicesActions.fetchAppDetailsStartAsync,
  updateAppStatus: edgeDevicesActions.updateAppStatusStartAsync,
  deleteApp: edgeDevicesActions.deleteAppStartAsync,
  scaleApp: edgeDevicesActions.scaleAppStartAsync,
  restartApp: edgeDevicesActions.restartAppStartAsync,
  fetchServices: edgeDevicesActions.fetchServicesStartAsync,
  fetchPods: edgeDevicesActions.fetchPodsStartAsync,
  fetchServiceStatus: edgeDevicesActions.fetchServiceStatusStartAsync,
  fetchPendingDevices: edgeDevicesActions.fetchPendingDevicesStartAsync,
  approveDevice: edgeDevicesActions.approveDeviceStartAsync,
  rejectDevice: edgeDevicesActions.rejectDeviceStartAsync,
  connectTerminal: edgeDevicesActions.connectTerminalStartAsync,
  disconnectTerminal: edgeDevicesActions.disconnectTerminal,
  executeCommand: edgeDevicesActions.executeTerminalCommandStartAsync,
  clearTerminalOutput: edgeDevicesActions.clearTerminalOutput,
  addTerminalOutput: edgeDevicesActions.addTerminalOutput,
  setActiveNamespace: edgeDevicesActions.setActiveNamespace,
  fetchRbacUsers: edgeDevicesActions.fetchRbacUsersAsync,
  inviteUser: edgeDevicesActions.inviteUserAsync,
  updateUserRole: edgeDevicesActions.updateUserRoleAsync,
  deleteUser: edgeDevicesActions.deleteUserAsync,
  fetchRoles: edgeDevicesActions.fetchRolesAsync,
};

/**
 * mapDispatchToProps using Redux's bindActionCreators
 */
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actionCreators, dispatch);
};

/**
 * EdgeContainer - Clean container component that only handles Redux connection
 * All data loading logic has been moved to individual child components
 * Each component handles its own loading states, no global spinner needed
 */
const EdgeContainer = compose(
  connect(mapStateToProps, mapDispatchToProps)
)(EdgeView);

export default EdgeContainer;